import { parseZonedDateTime } from '@internationalized/date';
import { CalendarEvent } from 'calendar-link';

interface EventInput {
  title: string;
  appointmentDate: string | null;
  appointmentTime: string | null;
  appointmentAddress: string;
  locationUrl: string;
  durationMinutes: number;
  description?: string;
}

export const createCalendarEvent = ({
  title,
  appointmentDate,
  appointmentTime,
  appointmentAddress,
  locationUrl,
  durationMinutes,
  description,
}: EventInput): CalendarEvent | null => {
  if (!appointmentDate || !appointmentTime) return null;

  const startDate = parseZonedDateTime(
    `${appointmentDate}T${appointmentTime}[America/New_York]`,
  ).toAbsoluteString();

  return {
    title,
    start: startDate,
    duration: [durationMinutes, 'minute'] as const,
    location: appointmentAddress,
    url: locationUrl,
    description: description || appointmentAddress,
  };
};
